export function TextInput({ name, placeholder, value, onChange }) {
  return (
    <input
      type="text"
      name={name}
      id={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className="flex-1 block w-full py-2 border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    />
  );
}
